import React from 'react';
import {FadeIn} from '../components/ui/FadeIn';
import {SectionLabel} from '../components/ui/SectionLabel';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMail,FiPhone,FiMapPin,FiClock}=FiIcons;

export const ContactPage=()=> {
  return ( 
    <div className="pt-24 md:pt-32 bg-ivory min-h-screen"> 
      {/* Hero Header */} 
      <section className="py-20 md:py-28 bg-charcoal"> 
        <div className="container mx-auto px-6 md:px-14 text-center"> 
          <FadeIn> 
            <SectionLabel light>Reach Out</SectionLabel> 
            <h1 className="font-serif text-4xl md:text-6xl text-white mb-4 italic">Contact Us</h1> 
            <p className="text-white/50 font-light text-sm mt-4 max-w-md mx-auto"> We'd love to hear from you — whether it's regarding a reservation, a private event, or general inquiries about our bistro. </p> 
            <div className="w-14 h-px bg-gold mx-auto mt-6" /> 
          </FadeIn> 
        </div> 
      </section> 

      {/* Contact Information Section */} 
      <section className="py-28 md:py-36 bg-ivory"> 
        <div className="container mx-auto px-6 md:px-14"> 
          <div className="max-w-4xl mx-auto"> 
            <div className="text-center mb-16"> 
              <FadeIn> 
                <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-6">Get In Touch</h2> 
                <p className="text-charcoal/60 font-light text-base leading-relaxed max-w-2xl mx-auto"> Maison De Charm is located in the heart of Singapore's historic Amoy Street. Our team is dedicated to providing you with an exceptional experience. </p> 
              </FadeIn> 
            </div> 
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16"> 
              {/* Left Column: Contact Details */} 
              <div className="space-y-10"> 
                {[ 
                  {icon: FiMapPin,label: 'Our Location',val: '85 Amoy St, Singapore 069904',desc: 'Situated in the central business district heritage enclave.'},
                  {icon: FiPhone,label: 'Reservations Hotline',val: '+65 8765 5023',desc: 'Available for calls and WhatsApp inquiries.'},
                  {icon: FiMail,label: 'General Inquiries',val: 'reservation@maisondecharm.com',desc: 'Expect a response within 24 hours.'},
                ].map(({icon,label,val,desc},i)=> ( 
                  <FadeIn key={label} direction="right" delay={i * 0.1}> 
                    <div className="flex gap-6 items-start p-6 bg-white border border-gold/5 shadow-sm hover:shadow-md transition-all duration-500"> 
                      <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0"> 
                        <SafeIcon icon={icon} className="text-gold text-xl" /> 
                      </div> 
                      <div> 
                        <p className="text-[10px] tracking-[0.25em] uppercase text-gold/60 mb-1 font-semibold">{label}</p> 
                        <p className="text-charcoal text-lg font-serif mb-1">{val}</p> 
                        <p className="text-charcoal/50 text-xs font-light">{desc}</p> 
                      </div> 
                    </div> 
                  </FadeIn> 
                ))} 
              </div> 
              {/* Right Column: Operating Hours & Note */} 
              <div className="space-y-10"> 
                <FadeIn direction="left" delay={0.2}> 
                  <div className="p-8 bg-charcoal text-white relative overflow-hidden h-full flex flex-col justify-center"> 
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" /> 
                    <div className="flex items-center gap-4 mb-6"> 
                      <SafeIcon icon={FiClock} className="text-gold text-2xl" /> 
                      <h3 className="font-serif text-2xl text-gold">Opening Hours</h3> 
                    </div> 
                    <div className="space-y-4 text-white/70 font-light text-sm"> 
                      <div className="flex justify-between border-b border-white/10 pb-2"> 
                        <span>Mon - Fri (Lunch)</span> 
                        <span className="text-white">12.00pm - 2.00pm</span> 
                      </div> 
                      <div className="flex justify-between border-b border-white/10 pb-2"> 
                        <span>Mon - Fri (Dinner)</span> 
                        <span className="text-white">6.30pm - 9.00pm</span> 
                      </div> 
                      <div className="flex justify-between border-b border-white/10 pb-2"> 
                        <span>Saturday</span> 
                        <span className="text-gold/60 uppercase tracking-widest text-[10px]">Private Events Only</span> 
                      </div> 
                      <div className="flex justify-between border-b border-white/10 pb-2"> 
                        <span>Sun & PH</span> 
                        <span className="text-gold/60 uppercase tracking-widest text-[10px]">Closed</span> 
                      </div> 
                    </div> 
                    <p className="text-[10px] text-gold/50 italic mt-8 leading-relaxed"> 
                      * Last seating: 2.00pm (Lunch), 8.00pm (Dinner). 
                    </p> 
                  </div> 
                </FadeIn> 
              </div> 
            </div> 
            <FadeIn delay={0.5} className="mt-24 text-center"> 
              <div className="inline-block p-1 bg-gold/10 rounded-full mb-6"> 
                <div className="px-6 py-2 bg-white rounded-full border border-gold/20"> 
                  <p className="text-[10px] tracking-[0.2em] uppercase text-gold font-bold">✦ Professional Service · Halal Fine Dining ✦</p> 
                </div> 
              </div> 
            </FadeIn> 
          </div> 
        </div> 
      </section> 
    </div> 
  );
};